import {
  gql
} from "@apollo/client"

export const GET_MINI_CART_FREQUENTLY_BOUGHT_URL_KEY = gql`
  query GetMiniCartFrequentlyBoughtTogether {
    shoes: products(
      pageSize: 36
      currentPage: 1
      filter: { category_uid: { eq: MTYy } }
      sort: { position: ASC }
    ) {
      items {
        url_key
      }
    }
    robes: products(
      pageSize: 36
      currentPage: 1
      filter: { category_uid: { eq: "MTc=" } }
      sort: { position: ASC }
    ) {
      items {
        url_key
      }
    }
    gifts: products(
      pageSize: 36
      currentPage: 1
      filter: { category_uid: { eq: "OQ==" } }
      sort: { position: ASC }
    ) {
      items {
        url_key
      }
    }
  }
`
